import { FormControl, Validators } from '@angular/forms';
import { AppForm } from '../../../../../../common/forms/app.form';

export class ManagerForm extends AppForm {
  constructor() {
    super({
      managerFirstName: new FormControl('', [Validators.required, Validators.maxLength(255)]),
      managerLastName: new FormControl('', [Validators.required, Validators.maxLength(255)]),
      managerPhone: new FormControl('', [Validators.required, Validators.maxLength(255)]),
      managerEmail: new FormControl('', [Validators.email, Validators.maxLength(255)]),
      managerCity: new FormControl('', [Validators.required, Validators.maxLength(255)]),
      managerStreet: new FormControl('', [Validators.maxLength(255)]),
      managerBuildingNumber: new FormControl('', [Validators.required, Validators.maxLength(255)]),
      managerHouseNumber: new FormControl('', [Validators.maxLength(255)]),
      managerPostalCode: new FormControl('', [Validators.required, Validators.maxLength(255)]),
      managerPostOffice: new FormControl('', [Validators.required, Validators.maxLength(255)])
    });
  }
}
